<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >

      <v-spacer></v-spacer>

      {{ version.describe }}
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>

    <v-dialog width="960" v-model="state.abortMessageIsVisible">
      <v-card title="Platform-Abort">
        <v-card-text>
          <p style="background-color: black">
            <center><img :src="guruMeditationGifUrl" /></center>
          </p>
          <pre v-text="state.abortMessage"></pre>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            @click="reload()"
          >
            Reload
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="state.asyncJobCount > 0">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
import state from '@/state';
import version from '@/version.json';
import guruMeditationGifUrl from '@/assets/guru-meditation.gif';

export default {
  data: () => ({
    state,
    version,
    guruMeditationGifUrl,
  }),

  methods: {
    reload() {
      location.reload();
    },
  },
};
</script>
